import React, { Component } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import Drawer           from '@material-ui/core/Drawer';
import List             from '@material-ui/core/List';
import ListItem         from '@material-ui/core/ListItem';
import ListItemText     from '@material-ui/core/ListItemText';
import CssBaseline      from '@material-ui/core/CssBaseline';
import Typography       from '@material-ui/core/Typography';
import clsx             from 'clsx';
import Card             from '@material-ui/core/Card';
import CardContent      from '@material-ui/core/CardContent';
import Grid             from '@material-ui/core/Grid';
import Box              from '@material-ui/core/Box';
import ColAtm           from "../../../atomic/Col/Col";
import 'react-circular-progressbar/dist/styles.css';
import PageHeaderAtm from "../../../atomic/PageHeader/PageHeader";
import Container from "@material-ui/core/Container";
import {PageTitle} from "../../../atomic/PageHeader/PageTitle"
import {Link} from "react-router-dom";
import {CarouselProvider, Slide, Slider} from "pure-react-carousel";
import IconButton from "@material-ui/core/IconButton";
import {CircularProgressbar} from "react-circular-progressbar";
import Divider from "@material-ui/core/Divider";
import ButtonAtm from "../../../atomic/Button/Button";
import {withTranslation} from "react-i18next";
import {compose} from "redux";
import {
    APP,
    BOOKING_ENGINE,
    CONTENT,
    NETWORK_CHANNELS,
    NETWORK_INVENTORY_LIST,
    NETWORK_RESERVATIONS,
    NETWORK_ROOM_AND_RATES,
    OFFER,
    PAYMENT,
    WEB,
    NETWORK_PROMOTION_CHANNEL_LIST,
    NOT_ALLOWED_DASHBOARD_SHORT,
    NETWORK_ADDONS_CHANNEL_LIST,
    NETWORK_COUPONS_CHANNEL_LIST,
    NETWORK_COMPETITOR,
    REPUTATION_MANAGEMENT,
    NETWORK_COMPETITOR_DASH
} from "../../../../constants/appUrls.constants";
import BottomNavigation from "@material-ui/core/BottomNavigation/BottomNavigation";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";
import {history} from "../../../../utils/history";
import {CircularProgress, Hidden} from "@material-ui/core";
import {getPropertyName, isDefined} from "../../../../utils";
import 'pure-react-carousel/dist/react-carousel.es.css';
import Carousel from '@brainhubeu/react-carousel';
import '@brainhubeu/react-carousel/lib/style.css';
import {connect} from "react-redux";
import {getNetworkDashboard} from "../../../../redux/actions/Network/Dashboard/networkDashboard.actions";
import {propertyProducts} from "../../../../redux/actions/propertyProductsActions";
import NotAllowedPage from "../../Global/NotAllowedPage/NotAllowedPage";
import Charts from "../../Global/Charts";
import { getProperty } from '../../../../utils';

import DashboardBottomActions from "../../../molecules/DashboardBottomActions/DashboardBottomActions";
import {getProfile} from "../../../../redux/actions/User/Profile/profileAction";
const drawerWidth = 91;
const drawerWidthCollapsed = 280;
const drawerWidthExpanded = 280;
const leftMenuWidth = 252;

const useStyles = makeStyles(theme => ({
    root: {
        display: 'block',
        width: '100%',
    },
    drawer: {
        width: drawerWidthCollapsed,
        flexShrink: 0,
        zIndex: '999',
    },
    leftMenu: {
        width: 0,
        flexShrink: 0,
    },
    leftMenuPaper: {
        width: leftMenuWidth,
        marginLeft: 102,
        marginTop: 81
    },
    drawerPaper: {
        width: drawerWidthCollapsed,
        height: 'calc(100vh - 81px)',
        marginTop: '81px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        background: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)',
        borderRight: '1px solid #e2e8f0',
        padding: '20px 12px',
        overflowX: 'hidden',
        overflowY: 'auto',
        transition: 'width 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        '&::-webkit-scrollbar': {
            width: 4,
        },
        '&::-webkit-scrollbar-track': {
            background: 'transparent',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#d1d5db',
            borderRadius: 4,
        },
        '@media (min-width: 960px) and (max-width: 1600px)': {
            height: 'calc(125vh - 101px)',
            minHeight: 'calc(125vh - 101px)',
        },
    },
    sidebarList: {
        padding: 0,
        margin: 0,
        listStyle: 'none',
        flex: '1 1 auto',
    },
    sidebarLink: {
        textDecoration: 'none',
        display: 'block',
        marginBottom: 8,
        '&:focus': {
            outline: 'none',
        },
    },
    sidebarItem: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: '12px 12px',
        borderRadius: 47,
        cursor: 'pointer',
        transition: 'background 0.2s ease',
        background: 'transparent',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        '&:hover': {
            background: '#f1f5f9',
        },
    },
    sidebarItemActive: {
        background: 'linear-gradient(135deg, #d71f26 0%, #ff4757 100%)',
        '&:hover': {
            background: 'linear-gradient(135deg, #d71f26 0%, #ff4757 100%)',
        },
    },
    sidebarIconWrapper: {
        minWidth: 34,
        width: 34,
        height: 34,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    },
    sidebarIcon: {
        fontSize: 18,
        color: '#64748b',
        transition: 'color 0.2s ease',
    },
    sidebarIconActive: {
        color: '#fff',
    },
    sidebarText: {
        fontSize: 13,
        fontWeight: 600,
        color: '#475569',
        marginLeft: 14,
        opacity: 1,
        transition: 'opacity 0.2s ease 0.1s',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        pointerEvents: 'none',
    },
    sidebarTextVisible: {
        opacity: 1,
    },
    sidebarTextActive: {
        color: '#fff',
    },
    sidebarDivider: {
        height: 1,
        background: '#e2e8f0',
        margin: '10px 8px',
        transition: 'margin 0.3s ease',
        '$drawerPaper:hover &': {
            margin: '10px 12px',
        },
    },
    chartsWrapper: {
        flex: '0 0 auto',
        padding: '16px 0',
        borderTop: '1px solid #e2e8f0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    appBarShift: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    leftBarShift: {
        width: `calc(100% - ${leftMenuWidth}px)`,
        marginLeft: drawerWidth,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: theme.spacing(2),
        backgroundColor: '#ffffff',
        padding: '11px 12.14px'
    },
    hide: {
        display: 'none',
    },
    contentShift: {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 125,
        marginRight: -60,
        paddingRight: 120,
    },
    content: {
        flexGrow: 1,
        padding: '24px 68px',
    },
    toolbar: theme.mixins.toolbar,
}));

class NetworkDashboard extends Component{

    componentDidMount() {
        // Sol menüdeki Panel / Site Ayarları butonları profil e-postasına bakıyor
        this.props.getProfile();
        document.body.style.backgroundColor = "#f4f7fc";
        this.props.getNetworkDashboard();
        this.props.propertyProducts();
    }

    render(){
        const dashboard = this.props.property_dashboard;
        const leftDrawer = this.props.left_drawer;
        const { t, networkDashboardReducer } = this.props;

        const allowedPage = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "network" === item.route)

        const allowedPageNetwork = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "network" === item.route)

        const allowedPageOffer = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "offer" === item.route)

        const allowedPageWeb = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "web" === item.route)

        const allowedPageBookingEngine = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "booking-engine" === item.route)

        const allowedPagePayment = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "payment" === item.route)

        const propertyProductCompetitor = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "competitor-analysis" === item.route)

        const allowedPageReputationManagement = !this.props.propertyProductsReducer.fetching &&
            isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            Object.values(this.props.propertyProductsReducer.get_products.data).filter(item => "reputation-management" === item.route)

        const propertyId = Number(getProperty());

        function Dashboard(props) {
            const classes = useStyles();

            function Sidebar(props) {
                const [isExpanded, setIsExpanded] = React.useState(false);
                const hoverTimeoutRef = React.useRef(null);
                const isNavigatingRef = React.useRef(false);

                const handleMouseEnter = () => {
                    if (isNavigatingRef.current) return;
                    
                    if (hoverTimeoutRef.current) {
                        clearTimeout(hoverTimeoutRef.current);
                    }
                    setIsExpanded(true);
                };

                const handleMouseLeave = () => {
                    if (hoverTimeoutRef.current) {
                        clearTimeout(hoverTimeoutRef.current);
                    }
                    hoverTimeoutRef.current = setTimeout(() => {
                        if (!isNavigatingRef.current) {
                            setIsExpanded(false);
                        }
                    }, 100);
                };

                const handleLinkClick = (e) => {
                    isNavigatingRef.current = true;
                    
                    const currentExpanded = isExpanded;
                    
                    setTimeout(() => {
                        isNavigatingRef.current = false;
                        setIsExpanded(currentExpanded);
                    }, 500);
                };

                // Cleanup
                React.useEffect(() => {
                    return () => {
                        if (hoverTimeoutRef.current) {
                            clearTimeout(hoverTimeoutRef.current);
                        }
                    };
                }, []);

                const sidebar = (
                    <div className={classes.root}>
                        <Drawer
                            className={classes.drawer}
                            variant="permanent"
                            classes={{
                                paper: classes.drawerPaper + " left-sidebar",
                            }}
                            PaperProps={{
                                onMouseEnter: handleMouseEnter,
                                onMouseLeave: handleMouseLeave,
                                style: {
                                    width: isExpanded ? drawerWidthExpanded : drawerWidthCollapsed,
                                },
                            }}
                        >
                            <List className={classes.sidebarList}>
                                {props.siderbarItems.map((post, key) => (
                                    <React.Fragment key={key}>
                                        <Link 
                                            to={post.link} 
                                            className={classes.sidebarLink}
                                            onClick={handleLinkClick}
                                        >
                                            <Box 
                                                className={`${classes.sidebarItem} ${post.isActive ? classes.sidebarItemActive : ''}`}
                                            >
                                                <Box className={classes.sidebarIconWrapper}>
                                                    <i 
                                                        className={`${post.icon} ${classes.sidebarIcon} ${post.isActive ? classes.sidebarIconActive : ''}`} 
                                                    />
                                                </Box>
                                                <Typography 
                                                    className={`${classes.sidebarText} ${post.isActive ? classes.sidebarTextActive : ''} ${isExpanded ? classes.sidebarTextVisible : ''}`}
                                                >
                                                    {post.text}
                                                </Typography>
                                            </Box>
                                        </Link>
                                    </React.Fragment>
                                ))}
                            </List>
                            {/* Panel + Site Ayarları: logonun üstünde */}
                            <DashboardBottomActions />

                            <Box className={classes.chartsWrapper}>
                                <Charts />
                            </Box>
                        </Drawer>
                    </div>
                );
                return (
                    <>
                        {sidebar}
                    </>
                );
            }

            const siderbarItems = [
                {id: 1, isActive: false, text: `${ t('enw-product_one-title') }`, icon: 'fas fa-hotel', link:"content"},
                {id: 4, isActive: false, text: `${t('enw-product_four-title') }`, icon: 'fas fa-network-wired', link: !props.propertyProductsReducer.fetching ? isDefined(allowedPageWeb[0]) && allowedPageWeb[0].property_has_product ? "web" : NOT_ALLOWED_DASHBOARD_SHORT + "/web" : "#"},
                {id: 5, isActive: false, text: `${t('enw-product_six-title')}`, icon: 'fas fa-calendar-alt', link: !props.propertyProductsReducer.fetching ? isDefined(allowedPageBookingEngine[0]) && allowedPageBookingEngine[0].property_has_product ? "booking-engine" : NOT_ALLOWED_DASHBOARD_SHORT + "/booking-engine" : "#"},
                {id: 6, isActive: false, text: `${t('enw-product_five-title') }`, icon: 'fas fa-money-bill-wave-alt', link: !props.propertyProductsReducer.fetching ? isDefined(allowedPagePayment[0]) && allowedPagePayment[0].property_has_product ? "payment" : NOT_ALLOWED_DASHBOARD_SHORT + "/payment" : "#"},
                {id: 3, isActive: false, text: `${t('enw-product_three-title') }`, icon: 'fas fa-paperclip', link: !props.propertyProductsReducer.fetching ? isDefined(allowedPageOffer[0]) && allowedPageOffer[0].property_has_product ? "offer" : NOT_ALLOWED_DASHBOARD_SHORT + "/offer" : "#"},
                {id: 2, isActive: true, text: `${t('enw-product_two-title') }`, icon: 'fas fa-chart-network', link: !props.propertyProductsReducer.fetching ? isDefined(allowedPageNetwork[0]) && allowedPageNetwork[0].property_has_product ? "network" : NOT_ALLOWED_DASHBOARD_SHORT + "/network" : "#"},
                {id: 7, isActive: false, text: (
                    <>
                        {t('enw-input-competitor')}
                        <span className="newBadge">{t('enw-new_title')}</span>
                    </>
                ), icon: 'fas fa-analytics', link: NETWORK_COMPETITOR_DASH },
                {id: 8, isActive: false, text: (
                        <>
                            {t('enw-reputation_management-title')}
                            <span className="newBadge">{t('enw-new_title')}</span>
                        </>
                ), icon: 'fas fa-comments-alt', link: !props.propertyProductsReducer.fetching ? isDefined(allowedPageReputationManagement[0]) && allowedPageReputationManagement[0].property_has_product ? REPUTATION_MANAGEMENT : NOT_ALLOWED_DASHBOARD_SHORT + "/reputation-management" : "#" },
            ];

            const [open] = React.useState(false);
            return (
                <ColAtm>
                    <ColAtm md={1} className="m-none" style={{ height: 'fit-content'}}>
                        <Sidebar siderbarItems={siderbarItems} />
                    </ColAtm>
                    <ColAtm sm={8} md={11} className="m-auto">
                        <div className={classes.root}>
                            <CssBaseline />
                            <Drawer
                                className={classes.leftMenu}
                                variant="persistent"
                                anchor="left"
                                open={open}
                                classes={{
                                    paper: classes.leftMenuPaper,
                                }}
                            >
                                <div className={classes.drawerHeader}>
                                    <IconButton className="drawer-back-button">
                                        <i className="fas fa-arrow-left" />
                                    </IconButton>
                                </div>
                                <ColAtm className="progress-bar-content">
                                    <CircularProgressbar
                                        className="profile-rate"
                                        counterClockwise
                                    />
                                    <p className="profile-power">
                                        Profile Rate
                                        <br/>
                                        <span className="bold-black-text"></span>
                                    </p>
                                    <Card className="drawer-info">
                                        <CardContent>
                                            <Typography variant="body2" color="textSecondary" component="p">
                                                You can increase the profile strength by starting to fill the Photo and amenties fields.
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                    <Divider />
                                    <ColAtm>
                                        <ColAtm>
                                            <Typography className="bold-black-text">
                                                What are the benefits of increasing Profile Strength?
                                            </Typography>
                                        </ColAtm>
                                        <ColAtm className="hints-padding">
                                            <ColAtm md={3} xl={2}>
                                                <i className="far fa-lightbulb-on hints-icon" />
                                            </ColAtm>
                                            <ColAtm className="hints-border" md={9} xl={10}>
                                                <Typography className="dashboard-hints" style={{textAlign:'left', paddingLeft: '10px'}}>
                                                    Completing your property's general informations
                                                </Typography>
                                            </ColAtm>
                                        </ColAtm>
                                        <Divider />
                                        <ColAtm className="hints-padding">
                                            <ColAtm md={3} xl={2}>
                                                <i className="far fa-lightbulb-on hints-icon" />
                                            </ColAtm>
                                            <ColAtm className="hints-border" md={9} xl={10}>
                                                <Typography className="dashboard-hints" style={{textAlign:'left', paddingLeft: '10px'}}>
                                                    Updating room details.
                                                </Typography>
                                            </ColAtm>
                                        </ColAtm>
                                        <Divider />
                                        <ColAtm className="hints-padding">
                                            <ColAtm md={3} xl={2}>
                                                <i className="far fa-lightbulb-on hints-icon" />
                                            </ColAtm>
                                            <ColAtm className="hints-border" md={9} xl={10}>
                                                <Typography className="dashboard-hints" style={{textAlign:'left', paddingLeft: '10px'}}>
                                                    Upload your property's photos
                                                </Typography>
                                            </ColAtm>
                                        </ColAtm>
                                        <Divider />
                                        <ButtonAtm className="photoUploadButton all-hints-button" buttontext={'All View'} fullwidth={true} />

                                    </ColAtm>
                                </ColAtm>
                            </Drawer>
                            <main
                                className={clsx("dashboard-content", {
                                    [classes.contentShift]: open,
                                })}
                            >
                                <div className={classes.drawerHeader} />
                                <div className={classes.root}>
                                    {
                                        isDefined(allowedPage[0]) && !allowedPage[0].property_has_product ?
                                            <Grid item xs={12} lg={11}>
                                                <Hidden xsDown>
                                                    <Card className="p-24 no-buy-product-content">
                                                        <NotAllowedPage />
                                                        <Carousel>
                                                        </Carousel>
                                                    </Card>
                                                </Hidden>
                                                <Hidden smUp>
                                                    <Card className="p-24 no-shadow">
                                                        <NotAllowedPage />
                                                        <Carousel>
                                                        </Carousel>
                                                    </Card>
                                                </Hidden>
                                            </Grid>
                                            :
                                            <Grid container spacing={3} className='mt-70-d'>
                                                {/* Sol Üst - Rezervasyon */}
                                                <Grid item xs={12} md={6} className="mobile-order-1">
                                                    <Card className="offer-dashboard__box-shadow pab-dashboard-elements" item xs={12}>
                                                        <Link to={NETWORK_RESERVATIONS}>
                                                            <Card className='border-shadow'>
                                                                <Grid container spacing={3}> {/* style={{height:"260px"}}  */}
                                                                    <ColAtm>
                                                                        <ColAtm className="m-general-dashboard" item xs={4}>
                                                                            <i className="fas fa-concierge-bell" style={{margin: "0 auto", color:"#d71f26", fontSize: 50, paddingTop: 47, paddingBottom: 47}} />
                                                                        </ColAtm>
                                                                        <ColAtm item xs={8}>
                                                                            <CardContent className="w-100">
                                                                                <Grid container>
                                                                                    <Grid item xs={11}>
                                                                                        <Typography className="red-title" gutterBottom variant="h5" component="h2">
                                                                                            { t('enw-reservation-title') }
                                                                                        </Typography>
                                                                                    </Grid>
                                                                                    <Grid item xs={1}>
                                                                                        <Typography className="completed-step" gutterBottom variant="h5" component="p">
                                                                                            <span className="red"><i className="fas fa-arrow-right" /></span>
                                                                                        </Typography>
                                                                                    </Grid>
                                                                                </Grid>
                                                                                <Typography variant="body2" color="textSecondary" component="p">
                                                                                    { t('enw-pab-dashboard-reservation-desc') }
                                                                                </Typography>
                                                                            </CardContent>
                                                                        </ColAtm>
                                                                    </ColAtm>
                                                                </Grid>
                                                            </Card>
                                                        </Link>
                                                        <ColAtm className="reservation-list-carousel">
                                                            <CarouselProvider
                                                                visibleSlides={7}
                                                                totalSlides={7}
                                                                step={1}
                                                                naturalSlideWidth={400}
                                                                naturalSlideHeight={500}
                                                            >
                                                                <Slider className="reservation-carousel">
                                                                    {!networkDashboardReducer.fetching && isDefined(networkDashboardReducer.networkDashboardData.reservation_count) ?
                                                                        Object.values(networkDashboardReducer.networkDashboardData.reservation_count).map((reservation, i) => (
                                                                            <Slide index={i} key={i}><span>{ t(reservation.abbreviation_day) }</span>{reservation.count}</Slide>
                                                                        ))
                                                                        :
                                                                        <CircularProgress color="inherit" size={28} />
                                                                    }
                                                                </Slider>
                                                            </CarouselProvider>
                                                        </ColAtm>
                                                    </Card>
                                                </Grid>

                                                {/* Sağ Üst - Kanallar */}
                                                <Grid item xs={12} md={6} className="mobile-order-2">
                                                    <Card className="offer-dashboard__box-shadow pab-dashboard-elements" item xs={12}>
                                                        <Link to={NETWORK_CHANNELS}>
                                                            <Card>
                                                                <Grid container spacing={3}>
                                                                    <ColAtm>
                                                                        <ColAtm className="channels_dashboard" item xs={4}>
                                                                            <i className="fas fa-chart-network" />
                                                                        </ColAtm>
                                                                        <ColAtm item xs={8}>
                                                                            <CardContent className='border-shadow'>
                                                                                <Grid container>
                                                                                    <Grid item xs={11}>
                                                                                        <Typography className="blue-title" gutterBottom variant="h5" component="h2">
                                                                                            { t('enw-channels-title') }
                                                                                        </Typography>
                                                                                    </Grid>
                                                                                    <Grid item xs={1}>
                                                                                        <Typography className="completed-step" gutterBottom variant="h5" component="p">
                                                                                            <span className="blue"><i className="fas fa-arrow-right" /></span>
                                                                                        </Typography>
                                                                                    </Grid>
                                                                                </Grid>
                                                                                <Typography variant="body2" color="textSecondary" component="p">
                                                                                    { t('enw-pab-dashboard-channels-desc') }
                                                                                </Typography>
                                                                            </CardContent>
                                                                            <ColAtm className="pab-inventory-desc-box">
                                                                                <p><span>{networkDashboardReducer.networkDashboardData.channel_count}</span> { t('enw-pab-dashboard-channels-counter_title') } </p>
                                                                            </ColAtm>
                                                                        </ColAtm>
                                                                    </ColAtm>
                                                                </Grid>
                                                            </Card>
                                                        </Link>
                                                    </Card>
                                                </Grid>

                                                {/* Sol Alt - Promosyon */}
                                                <Grid item xs={12} md={6} className="mobile-order-4">
                                                    <Card className="offer-dashboard__box-shadow room-box mobile-mb-0" item xs={12}>
                                                        <Card>
                                                            <Grid container spacing={3}>
                                                                <ColAtm>
                                                                    <ColAtm className="room_dashboard promotion" item xs={4}>
                                                                        <i className="fas fa-percent" />
                                                                    </ColAtm>
                                                                    <ColAtm item xs={8} className="border-shadow">
                                                                        <CardContent className="w-100">
                                                                            <Link to={NETWORK_PROMOTION_CHANNEL_LIST}>
                                                                                <Grid container>
                                                                                    <Grid item xs={11}>
                                                                                        <Typography className="orange-title" gutterBottom variant="h5" component="h2">
                                                                                            { t('enw-pab-dashboard-promotion-title') }
                                                                                        </Typography>
                                                                                    </Grid>
                                                                                    <Grid item xs={1}>
                                                                                        <Typography className="completed-step" gutterBottom variant="h5" component="p">
                                                                                            <span className="orange"><i className="fas fa-arrow-right fs-16" /></span>
                                                                                        </Typography>
                                                                                    </Grid>
                                                                                </Grid>
                                                                                <Typography variant="body2" color="textSecondary" component="p">
                                                                                    { t('enw-pab-dashboard-promotion-desc') }
                                                                                </Typography>
                                                                            </Link>
                                                                        </CardContent>
                                                                    </ColAtm>
                                                                </ColAtm>
                                                                <ColAtm className="carousel-col general-carousel network-promotion-dashboard-menu">
                                                                    <Hidden xsDown>
                                                                        <ColAtm className="carousel-col general-carousel">
                                                                            <Link to={NETWORK_PROMOTION_CHANNEL_LIST}>
                                                                                { t('enw-promotion-dashboard-title') }
                                                                            </Link>
                                                                            <Link to={NETWORK_ADDONS_CHANNEL_LIST}>
                                                                                { t('enw-addon-dashboard-title') }
                                                                            </Link>
                                                                            <Link to={NETWORK_COUPONS_CHANNEL_LIST}>
                                                                                { t('enw-coupon-dashboard-title') }
                                                                            </Link>
                                                                        </ColAtm>
                                                                    </Hidden>
                                                                    <Hidden smUp>
                                                                        <Carousel slidesPerPage={3}
                                                                                infinite
                                                                                keepDirectionWhenDragging
                                                                                arrowLeft={<i className="fas fa-caret-left" />}
                                                                                arrowRight={<i className="fas fa-caret-right" />}
                                                                                addArrowClickHandler
                                                                                arrows
                                                                        >
                                                                            <Link to={NETWORK_PROMOTION_CHANNEL_LIST}>
                                                                                { t('enw-promotion-dashboard-title') }
                                                                            </Link>
                                                                            <Link to={NETWORK_ADDONS_CHANNEL_LIST}>
                                                                                { t('enw-addon-dashboard-title') }
                                                                            </Link>
                                                                            <Link to={NETWORK_COUPONS_CHANNEL_LIST}>
                                                                                { t('enw-coupon-dashboard-title') }
                                                                            </Link>
                                                                        </Carousel>
                                                                    </Hidden>
                                                                </ColAtm>
                                                            </Grid>
                                                        </Card>
                                                    </Card>
                                                </Grid>

                                                {/* Sağ Alt - Envanter */}
                                                <Grid item xs={12} md={6} className="mobile-order-3">
                                                    <Card className="offer-dashboard__box-shadow pab-dashboard-elements">
                                                        <Link to={NETWORK_INVENTORY_LIST}>
                                                            <Card>
                                                                <Grid container spacing={3}>
                                                                    <ColAtm>
                                                                        <ColAtm className="inventory-dashboard" item xs={4}>
                                                                            <i className="far fa-calendar-alt" />
                                                                        </ColAtm>
                                                                        <ColAtm item xs={8}>
                                                                            <CardContent className="border-shadow">
                                                                                <Grid container>
                                                                                    <Grid item xs={11}>
                                                                                        <Typography className="green-title" gutterBottom variant="h5" component="h2">
                                                                                            {t('enw-inventory-title')}
                                                                                        </Typography>
                                                                                    </Grid>
                                                                                    <Grid item xs={1}>
                                                                                        <Typography className="completed-step" gutterBottom variant="h5" component="p">
                                                                                            <span><i className="fas fa-arrow-right" /></span>
                                                                                        </Typography>
                                                                                    </Grid>
                                                                                </Grid>
                                                                                <Typography variant="body2" color="textSecondary" component="p">
                                                                                    {t('enw-pab-dashboard-inventory-desc')}
                                                                                </Typography>
                                                                            </CardContent>
                                                                        </ColAtm>
                                                                    </ColAtm>
                                                                </Grid>
                                                            </Card>
                                                        </Link>
                                                    </Card>
                                                </Grid>
                                            </Grid>
                                    }
                                </div>
                            </main>
                        </div>
                    </ColAtm>
                    <style>{`
                    @media screen and (max-width: 768px) {
                        .dashboard-tools > div:nth-last-child(-n + 2) {
                            margin-top:5px !important;
                        }
                    }
                    .MuiDrawer-paper::-webkit-scrollbar {
                        width: 4px;
                    }

                    .MuiDrawer-paper::-webkit-scrollbar-track {
                        background: transparent;
                    }

                    .MuiDrawer-paper::-webkit-scrollbar-thumb {
                        background: #d1d5db;
                        border-radius: 4px;
                    }

                    .MuiDrawer-paper::-webkit-scrollbar-thumb:hover {
                        background: #9ca3af;
                    }

                    @media (min-width: 960px) and (max-width: 1600px) {
                        .MuiDrawer-paper {
                            height: calc(125vh - 81px) !important;
                            min-height: calc(125vh - 101px) !important;
                        }
                        
                        .sidebar-items, .active-sidebar {
                            padding: 10px 14px !important;
                        }
                        
                        .sidebar-items i,
                        .active-sidebar i {
                            font-size: 16px !important;
                        }
                        
                        .dashboard-menu {
                            font-size: 12px !important;
                        }
                    }

                    .MuiDrawer-paper {
                        &:hover {
                            .sidebar-text-animated {
                                opacity: 1 !important;
                                transform: translateX(0) !important;
                            }
                        }
                    }
                    @media (min-width: 1300px) {
                        .be-container-width, .dashboard-content {
                            padding: 40px 70px 0px 150px !important;
                        }
                    }
                `}</style>
                </ColAtm>
            );
        }
        return(
            <>
                <PageTitle title={ t('enw-pab-page_title') } />
                <PageHeaderAtm exitText={ t('btn-properties') } backButton={APP} text={ getPropertyName() } />
                <Container maxWidth="xl">
                    <div className="pab-container-width">
                        <Dashboard dashboard={dashboard} leftDrawer={leftDrawer} propertyProductsReducer={this.props.propertyProductsReducer} />
                    </div>
                </Container>
                <Hidden mdUp>
                    <BottomNavigation className="m-navigation" value="network">
                        <BottomNavigationAction value="content" icon={<i className="fas fa-hotel" />} onClick={() => { history.push(CONTENT)}} />
                        <BottomNavigationAction value="web" icon={<i className="fas fa-network-wired" />} onClick={() => { history.push(!this.props.propertyProductsReducer.fetching ? isDefined(allowedPageWeb[0]) && allowedPageWeb[0].property_has_product ? WEB :  NOT_ALLOWED_DASHBOARD_SHORT + "/web" : "#")}} />
                        <BottomNavigationAction value="booking" icon={<i className="fas fa-calendar-alt" />} onClick={() => { history.push(!this.props.propertyProductsReducer.fetching ? isDefined(allowedPageBookingEngine[0]) && allowedPageBookingEngine[0].property_has_product ? BOOKING_ENGINE :  NOT_ALLOWED_DASHBOARD_SHORT + "/booking-engine" : "#")}} />
                        <BottomNavigationAction value="payment" icon={<i className="fas fa-money-bill-wave-alt" />} onClick={() => { history.push(!this.props.propertyProductsReducer.fetching ? isDefined(allowedPagePayment[0]) && allowedPagePayment[0].property_has_product ? PAYMENT :  NOT_ALLOWED_DASHBOARD_SHORT + "/payment" : "#")}} />
                        <BottomNavigationAction value="offer" icon={<i className="fas fa-paperclip" />} onClick={() => { history.push(!this.props.propertyProductsReducer.fetching ? isDefined(allowedPageOffer[0]) && allowedPageOffer[0].property_has_product ? OFFER : NOT_ALLOWED_DASHBOARD_SHORT + "/offer" : "#")}} />
                        <BottomNavigationAction value="network" icon={<i className="fas fa-chart-network" />}/>
                        <BottomNavigationAction value="competitor-analysis" icon={<i className="fas fa-analytics" />} onClick={() => { history.push(NETWORK_COMPETITOR_DASH) }} />
                        <BottomNavigationAction
                            value="reputation-management"
                            icon={<i className="fas fa-comments-alt" />}
                            onClick={() => { history.push(!this.props.propertyProductsReducer.fetching ? isDefined(allowedPageReputationManagement[0]) && allowedPageReputationManagement[0].property_has_product ? REPUTATION_MANAGEMENT : NOT_ALLOWED_DASHBOARD_SHORT + "/reputation-management" : "#")}}
                        />
                    </BottomNavigation>
                </Hidden>
            </>
        );
    }
}

const mapStateToProps = (props) => {
    return {
        networkDashboardReducer : props.networkDashboardReducer,
        propertyProductsReducer : props.propertyProductsReducer
    }
};

const mapDispatchToProps = {
    getProfile,
    getNetworkDashboard,
    propertyProducts
};

export default compose(withTranslation('common')) (connect(mapStateToProps, mapDispatchToProps )(NetworkDashboard));

